/**
 * Labstep
 *
 * @module grid/Report/components/ToolPanel/Protocol
 * @desc Hardcoded list of columns for experiment fields
 */

import { Flex } from 'labstep-web/core/Flex';
import { SectionHeader } from 'labstep-web/core/Header';
import {
  experimentEndedAtColDef,
  experimentStartedAtColDef,
  protocolNameColDef,
} from 'labstep-web/grid/Report/coldefs';
import { EntityDataGridToolPanelListItem } from 'labstep-web/grid/Report/components/ToolPanel/ListItem';
import { GridToolBarService } from 'labstep-web/grid/services/grid-toolbar.service';
import type React from 'react';
import type { IEntityDataGridToolPanelProtocolProps } from './types';

export const EntityDataGridToolPanelProtocol: React.FC<
  IEntityDataGridToolPanelProtocolProps
> = ({ gridReportService, searchQuery, colIds }) => (
  <Flex column>
    {GridToolBarService.showListSection(
      ['protocol name', 'started date', 'completion date'],
      searchQuery,
    ) && <SectionHeader label="Protocol Fields" />}
    {GridToolBarService.showListItem(
      'protocol name',
      searchQuery,
    ) && (
      <EntityDataGridToolPanelListItem
        icon="tasks"
        actionIcon="eye"
        text="Protocol Name"
        onClick={() => {
          gridReportService.addColumnDef(protocolNameColDef);
        }}
        disabled={
          protocolNameColDef.colId
            ? colIds.includes(protocolNameColDef.colId)
            : false
        }
      />
    )}
    {GridToolBarService.showListItem('started date', searchQuery) && (
      <EntityDataGridToolPanelListItem
        icon="calendar outline"
        actionIcon="eye"
        text="Started Date"
        onClick={() => {
          gridReportService.addColumnDef(experimentStartedAtColDef);
        }}
        disabled={
          experimentStartedAtColDef.colId
            ? colIds.includes(experimentStartedAtColDef.colId)
            : false
        }
      />
    )}
    {GridToolBarService.showListItem(
      'completion date',
      searchQuery,
    ) && (
      <EntityDataGridToolPanelListItem
        icon="calendar check outline"
        actionIcon="eye"
        text="Completion Date"
        onClick={() => {
          gridReportService.addColumnDef(experimentEndedAtColDef);
        }}
        disabled={
          experimentEndedAtColDef.colId
            ? colIds.includes(experimentEndedAtColDef.colId)
            : false
        }
      />
    )}
  </Flex>
);
